module.exports = __webpack_public_path__ + "img/defaultAvatar_Female.0ef2359b.jpg";